import { render, staticRenderFns } from "./Bookmark.vue?vue&type=template&id=2d0bdf76&scoped=true&"
import script from "./Bookmark.vue?vue&type=script&lang=js&"
export * from "./Bookmark.vue?vue&type=script&lang=js&"
import style0 from "./Bookmark.vue?vue&type=style&index=0&id=2d0bdf76&prod&scoped=true&lang=css&"
import style1 from "./Bookmark.vue?vue&type=style&index=1&id=2d0bdf76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0bdf76",
  null
  
)

export default component.exports